<template>
	<div
		id="user-management"
		:class="[!isWeb ? 'mobile-user-management' : '', !isWeb && isSafari ? 'safari' : '']"
	>
		<div class="user-management__body">
			<TableFilter
				:isWeb="isWeb"
				@searchFromInput="searchFromInput"
				@searchFromStatusInput="searchFromStatusInput"
			/>
			<UserTable
				:isWeb="isWeb"
				:currentPage="page"
				@changePage="changePage"
				@refreshUsers="refreshUsers"
				@orderByHeader="orderByHeader"
			/>
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { GET_ALL_USERS, GET_USER_STATUS } from '@/store/modules/userManagement/actions';
import TableFilter from '@/components/modules/User/UserManagement/TableFilter/TableFilter.vue';
import UserTable from '@/components/modules/User/UserManagement/Table/Table.vue';

export default {
	name: 'UserManagement',
	components: { TableFilter, UserTable },
	data: () => ({
		windowWidth: window.innerWidth,
		page: 1,
		searchParams: null,
		headerSelected: null,
		orderSelected: null,
		statusSelected: null,
	}),
	created() {
		this.refreshUsers();
		this.getUserStatus({ vm: this });
	},
	mounted() {
		this.$nextTick(() => {
			window.addEventListener('resize', this.onResize);
		});
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.onResize);
	},
	methods: {
		...mapActions('userManagement', {
			getUsers: GET_ALL_USERS,
			getUserStatus: GET_USER_STATUS,
		}),
		onResize() {
			this.windowWidth = window.innerWidth;
		},
		changePage(params) {
			this.page = params.params;
			this.refreshUsers();
		},
		searchFromInput(params) {
			this.searchParams = params;
			this.page = 1;
			this.refreshUsers();
		},
		searchFromStatusInput(params) {
			this.statusSelected = params;

			this.refreshUsers();
		},
		orderByHeader(param) {
			if (this?.headerSelected === param) {
				if (this.orderSelected === 'ASC') {
					this.orderSelected = 'DESC';
				} else {
					this.orderSelected = 'ASC';
				}
			} else {
				this.orderSelected = 'DESC';
			}
			this.headerSelected = param;
			this.refreshUsers();
		},
		refreshUsers() {
			let params = `?limit=20&page=${this.page}`;
			if (this.searchParams) params += `&search=${this.searchParams}`;
			if (this.headerSelected)
				params += `&orderColumn=${this.headerSelected}&orderDirection=${this.orderSelected}`;
			if (this.statusSelected != null) params += `&status=${this.statusSelected}`;

			this.getUsers({ vm: this, params: params });
		},
	},
	computed: {
		...mapGetters('userManagement', ['isLoadingUsers']),
		isWeb() {
			return this.windowWidth > 992;
		},
		isSafari() {
			return navigator.vendor == 'Apple Computer, Inc.';
		},
	},
};
</script>

<style lang="scss">
@import 'UserManagement.scss';
</style>
